module.exports = __webpack_public_path__ + "img/11-min.7bc07a5a.jpg";